/**
 * @author        quanquan
 * @dateTime      2020-12-07 18:02:14
 * @description   meituanIM
 */

import MC from '@/module/MC'
import io, { serverAlias } from '@/module/io'

class MeituanIM {
  /**
   * 获取网店列表
   */
  getClientList (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/client-list`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 美团授权
   */
  meituanAuth (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/_authorize`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 同步门店
   */
  meituanSynStore (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/_synStoreData`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 获取用户列表
   */
  getStoreUsers (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/getStoreUsers`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 查询门店列表
   */
  getStoreList (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/store-list`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 查询授权网店
   */
  getAuthorizedStore (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/authorizeClient-list`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 获取美团长链接token
   */
  getMeituanToken (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/_getToken`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 查询单个门店
   "merCode": "string",
   "onlineStoreCode": "string"
   */
  getSingleStore (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/getSingleStore`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 查询单个用户
   "merCode": "string",
   "onlineStoreCode": "string",
   "thirdUserId": "string"
   */
  getSingleUser (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/getSingleUser`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 查询历史消息
   "appPoiCode": "string",
   "currentPage": 0,
   "merCode": "string",
   "openUserId": "string",
   "pageSize": 0
   */
  getHistoryMessage (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/getHistoryMessage`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 客服消息上报
   */
  messageIMReport (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/msgReport`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 未读消息数上报
   */
  unreadMsgReport (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/unreadMsgReport`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 转换美团文件
   */
  transMtFile (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/meituanIM/_transMtFile`, { ...payload, merCode }, res => {
        resolve('hydee-middle-push/999999/20201217/0ed6b39646354af7a28f10841940d4d7.amr')
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }
}

export default new MeituanIM()



// WEBPACK FOOTER //
// ./src/js/module/apis/meituanIM.js